// src/utils/blockedUrls.js
export const reservationAuth = [
    //의료진검색
    '/hospital/department-doctor/doctor.do',

    //진료과
    '/hospital/department-doctor/departmentDetail.do',

    //진료일정표
    '/hospital/department-doctor/treatmentChart.do',

    //의료진상세보기
    '/hospital/department-doctor/doctorDetail.do'
];